const { BASE_URL } = require("./client");

const GET_PRESIGNED_URL = BASE_URL + "/api/getPreSignedUploadUrl";

module.exports = {
  GET_PRESIGNED_URL,
};
